// W13-1b — THE PERMISSION MOMENT, AS A SURFACE. Props in, tree out, NO HOOKS, so a gate CALLS it.
//
// That is the entry requirement every extraction in this repo has had, and it matters more here than
// usual: the whole reason this feature was reported missing is that nothing could see whether it
// rendered. The decision itself is `shouldOfferPush` in `src/pushOptIn.js` (also hookless, also RUN
// by the gate); App.tsx owns the one effect that asks it.
//
// **IT IS A STATUS SHEET, NOT A MODAL.** UpdateBanner made the same call for the same reason: a
// member who opened the app to do something should not be blocked by a question she did not ask.
// It is dismissible, and dismissing it is a real recorded answer ("later"), not a disappearance.
import { PUSH_COPY } from "../pushOptIn.js";

export function PushOptInSheet({ open, onAccept, onLater }: {
  open: boolean;
  onAccept: () => void;
  onLater: () => void;
}) {
  if (!open) return null;
  return (
    <div className="push-optin" role="status" aria-live="polite">
      <div className="push-optin__body">
        <strong className="push-optin__title">{PUSH_COPY.title}</strong>
        <p className="push-optin__text">{PUSH_COPY.body}</p>
      </div>
      <div className="push-optin__actions">
        {/* HER TAP IS THE GESTURE. `Notification.requestPermission()` may only be called from a user
            gesture, so this button is not a preference toggle — it is the thing that is legally
            allowed to raise the browser's own prompt, and the sentence above it is what makes that
            one irreversible choice an informed one. */}
        <button type="button" className="button push-optin__yes" onClick={onAccept}>{PUSH_COPY.accept}</button>
        <button type="button" className="push-optin__later" onClick={onLater}>{PUSH_COPY.later}</button>
      </div>
    </div>
  );
}
